import Vue from 'vue';
import VueRouter from 'vue-router';
import Home from '../views/Home.vue';
import store from "@/store";

Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home,
    children: [
      {
        path: '/',
        component: () => import('@/components/Layout/Landing/Landing.vue'),
      },
      {
        path: '/programs',
        component: () => import('@/components/Layout/Programs/Program.vue'),
      },
      {
        path: '/campaigns',
        component: () => import('@/components/Layout/Campaign/Campaigns.vue'),
      },
      {
        path: '/site',
        component: () => import('@/components/Layout/Site/Site.vue'),
      },
      {
        path: "/toplist",
        component: () => import("@/components/Layout/Toplist/Toplist")
      }
    ]
  },
  {
    path: '*',
    redirect: '/'
  }
];

const router = new VueRouter({
  mode: 'history',
  routes,
});

router.afterEach(() => {
  store.dispatch('checkCookieConsent');
});

export default router;
